const SET_WINDOW_SIZE = 'SET_WINDOW_SIZE'

export { SET_WINDOW_SIZE }
